<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			(setDialogHide) => {
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">đơn {{ data.type == 1 ? "mua" : "bán" }}</h4>
			<!-- <h4 v-else class="uppercase font-bold block text-xl w-full">LỆNH MUA NGAY</h4>
			<p class="text-base text-black font-medium">{{ data.device ? data.device.name : "" }}</p> -->
		</div>
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6" v-if="isPopupActiveLocal">
				<div class="mb-5">
					<label for class="text-base vs-input--label">Loại phụ phẩm <span class="text-danger">*</span>: </label>
					<v-select
						:clearable="false"
						class="border-none w-full"
						:placeholder="`Chọn phụ phẩm`"
						v-model="product"
						name="product"
						:options="$store.state.moduleProduct.products"
						:reduce="(p) => p.id"
						label="name"
						:data-vv-as="'Phụ phẩm'"
						v-validate="'required'"
						required="true"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('product')">{{ errors.first("product") }}</span>
				</div>
				<!-- NAME -->
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Khối lượng (kg)
						<span class="text-danger">*</span>:
					</label>
					<cbs-input type="number" inputmode="numeric" pattern="[0-9]*" v-model="quantity" class="w-full" name="quantity" :data-vv-as="'Khối lượng'" :placeholder="`${$t('Input')} ${'Khối lượng'}`" v-validate="'required'" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('quantity')">{{ errors.first("quantity") }}</span>
				</div>
				<!-- NAME -->
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Đơn giá (đ)
						<span class="text-danger">*</span>:
					</label>
					<cbs-input type="number" inputmode="numeric" pattern="[0-9]*" v-model="price" class="w-full" name="price" :data-vv-as="'Đơn giá'" :placeholder="`${$t('Input')} ${'Đơn giá'}`" v-validate="'required'" />
					<span class="text-default text-sm break-normal">Đã bao gồm VAT</span>
					<span class="text-danger text-sm break-normal" v-show="errors.has('price')">{{ errors.first("price") }}</span>
				</div>
				<div class="mb-5" v-if="data.type==2 && canSelectSupplier">
					<label for class="text-base vs-input--label"> Chọn nhà cung cấp <span class="text-danger">*</span>: </label>
					<v-select
						:clearable="false"
						class="border-none w-full"
						:placeholder="`Chọn nhà cung cấp`"
						v-model="supplier"
						name="supplier"
						:options="$store.state.moduleProduct.suppliers"
						:reduce="(p) => p.id"
						label="name"
						:data-vv-as="'Nhà cung cấp'"
						v-validate="'required'"
						required="true"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('supplier')">{{ errors.first("supplier") }}</span>
				</div>
				<div v-if="supplier==0 && data.type==2 && canSelectSupplier">
					<!-- NAME -->
					<div class="mb-5">
						<label for class="text-base vs-input--label"> Tên nhà cung cấp: </label>
						<cbs-input v-model="supplier_name" class="w-full" name="supplier_name" :data-vv-as="'Tên nhà cung cấp'" :placeholder="`${$t('Input')} ${'Tên nhà cung cấp'}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('supplier_name')">{{ errors.first("supplier_name") }}</span>
					</div>
					<!-- NAME -->
					<div class="mb-5" v-if="data.type == 2">
						<label for class="text-base vs-input--label"> Điện thoại NCC: </label>
						<cbs-input v-model="supper_phone" class="w-full" name="supper_phone" :data-vv-as="'Điện thoại NCC'" :placeholder="`${$t('Input')} ${'Điện thoại NCC'}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('supper_phone')">{{ errors.first("supper_phone") }}</span>
					</div>
					<!-- NAME -->
					<div class="mb-5" v-if="data.type == 2">
						<label for class="text-base vs-input--label"> Mã số thuế NCC: </label>
						<cbs-input v-model="supper_mst" class="w-full" name="supper_mst" :data-vv-as="'Mã số thuế NCC'" :placeholder="`${$t('Input')} ${'Mã số thuế NCC'}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('supper_mst')">{{ errors.first("supper_mst") }}</span>
					</div>
					<!-- NAME -->
					<div class="mb-5" v-if="data.type == 2">
						<label for class="text-base vs-input--label"> Số tài khoản: </label>
						<cbs-input v-model="supplier_bankaccount" class="w-full" name="supplier_bankaccount" :data-vv-as="'Số tài khoản'" :placeholder="`${$t('Input')} ${'Số tài khoản'}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('supplier_bankaccount')">{{ errors.first("supplier_bankaccount") }}</span>
					</div>
					<!-- NAME -->
					<div class="mb-5" v-if="data.type == 2">
						<label for class="text-base vs-input--label"> Ngân hàng: </label>
						<cbs-input v-model="supplier_bankname" class="w-full" name="supplier_bankname" :data-vv-as="'Ngân hàng'" :placeholder="`${$t('Input')} ${'Ngân hàng'}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('supplier_bankname')">{{ errors.first("supplier_bankname") }}</span>
					</div>
					<!-- NAME -->
					<div class="mb-5" v-if="data.type == 2">
						<label for class="text-base vs-input--label"> Chủ tài khoản: </label>
						<cbs-input v-model="supplier_bankowner" class="w-full" name="supplier_bankowner" :data-vv-as="'Chủ tài khoản'" :placeholder="`${$t('Input')} ${'Chủ tài khoản'}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('supplier_bankowner')">{{ errors.first("supplier_bankowner") }}</span>
					</div>
				</div>
				<!-- NAME -->
				<fieldset class="fieldset-custom mb-5">
					<legend>Địa chỉ {{data.type == 2 ? 'kho hàng' : 'nhận hàng'}}:</legend>
					<div class="mb-5">
						<label for class="text-base vs-input--label">Tỉnh/tp: </label>
						<v-select
							:clearable="false"
							class="border-none w-full"
							:placeholder="`Chọn Tỉnh/tp`"
							v-model="province"
							name="province"
							:options="$store.state.moduleProduct.provinces"
							:reduce="(p) => p.id"
							label="name"
							:data-vv-as="'Tỉnh/tp'"
						/>
						<span class="text-danger text-sm break-normal" v-show="errors.has('province')">{{ errors.first("province") }}</span>
					</div>
					<div class="mb-5">
						<label for class="text-base vs-input--label">Quận/huyện: </label>
						<v-select
							:clearable="false"
							class="border-none w-full"
							:placeholder="`Chọn Quận/huyện`"
							v-model="district"
							name="district"
							:options="districts"
							:reduce="(p) => p.id"
							label="name"
							:data-vv-as="'Quận/huyện'"
						/>
						<span class="text-danger text-sm break-normal" v-show="errors.has('district')">{{ errors.first("district") }}</span>
					</div>
					<div class="mb-5">
						<label for class="text-base vs-input--label"> Tên đường, tên {{data.type == 2 ? 'kho hàng' : 'kho nhận'}}: </label>
						<cbs-input v-model="address" class="w-full" name="address" :data-vv-as="'Tên đường'" :placeholder="`${$t('Input')} ${'Tên đường'}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('address')">{{ errors.first("address") }}</span>
					</div>
				</fieldset>
				<!-- NAME -->
				<div class="mb-5">
					<label for class="text-base vs-input--label"> Ghi chú: </label>
					<cbs-input v-model="cus_note" class="w-full" name="cus_note" :data-vv-as="'Ghi chú'" :placeholder="`${$t('Input')} ${'Ghi chú'}`" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('cus_note')">{{ errors.first("cus_note") }}</span>
				</div>
				<!-- NAME -->
				<div class="mb-5" v-if="data.type == 2">
					<label for class="text-base vs-input--label">
						 Hình ảnh thực tế
						<span class="text-danger">*</span>:
					</label>
					<cbs-upload-ref
						:key="timeKey"
						value="value"
						v-model="localAttachFile"
						accept="image/*"
						:limit="10"
						:on-exceed="() => $vs.notify({ title: $t('Notify.Notification'), text: $t('OnlyOneFileUpload') })"
					/>
					<span class="text-danger text-sm break-normal" v-show="customErrors != null">{{ customErrors }}</span>
				</div>
				<vs-row v-if="data.type == 2">
					<vs-col vs-w="12" style="display: flex; vertical-align: middle;">
						<vs-checkbox name="prevent_slit" v-model="prevent_slit" color="primary" id="prevent_slit" />
						<label for="prevent_slit" class="text-base vs-input--label">
							Chỉ bán nguyên lô, không tách đơn
						</label>
					</vs-col>
				</vs-row>
				<div class="mb-5" v-if="data.type == 2">
					<span class="text-default text-sm break-normal">Khi người mua khớp lệnh với số lượng ít hơn, đơn này sẽ được tách ra. Tick chọn để ngăn lại</span>
				</div>

				<vs-row class="mb-5" v-if="data.type == 2">
					<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
						<vs-radio name="shipping_method" v-model="shipping_method" color="primary" id="shipping_method" vs-value="1" />
						<label for="shipping_method" class="text-base vs-input--label">
							Tự vận chuyển
						</label>
					</vs-col>
					<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
						<vs-radio name="shipping_method_req" v-model="shipping_method" color="primary" id="shipping_method_req" vs-value="2" />
						<label for="shipping_method_req" class="text-base vs-input--label">
							Yêu cầu vận chuyển
						</label>
					</vs-col>
				</vs-row>
				<div class="mb-5" v-if="data.type == 2 && shipping_method == 1">
					<fieldset class="fieldset-custom mb-5">
						<legend>Giá vận chuyển dự kiến:</legend>
						<div :key="indextr" v-for="(place, indextr) in placeData">
							<div class="mb-5">
								<label for class="text-base vs-input--label">
									Về {{place.name}} bằng ghe:
								</label>
								<cbs-input type="number" inputmode="numeric" pattern="[0-9]*" v-model="priceMaps[`${place.id}_2`]" class="w-full" :name="`place_name${place.id}_2`" :data-vv-as="'Nhập giá vận chuyển'" :placeholder="`${'đ/kg (Bỏ trống nếu không giao cách này)'}`"/>
								<span class="text-danger text-sm break-normal" v-show="errors.has(`place_name${place.id}_2`)">{{ errors.first(`place_name${place.id}_2`) }}</span>
							</div>
							<div class="mb-5">
								<label for class="text-base vs-input--label">
									Về {{place.name}} bằng xe:
								</label>
								<cbs-input type="number" inputmode="numeric" pattern="[0-9]*" v-model="priceMaps[`${place.id}_1`]" class="w-full" :name="`place_name${place.id}_1`" :data-vv-as="'Nhập giá vận chuyển'" :placeholder="`${'đ/kg (Bỏ trống nếu không giao cách này)'}`"/>
								<span class="text-danger text-sm break-normal" v-show="errors.has(`place_name${place.id}_1`)">{{ errors.first(`place_name${place.id}_1`) }}</span>
							</div>
						</div>
					</fieldset>
				</div>
				
				<vs-row v-if="data.type == 1">
					<vs-col vs-w="12" style="display: flex; vertical-align: middle;">
						<vs-checkbox name="require_qc" v-model="require_qc" color="primary" id="require_qc" />
						<label for="require_qc" class="text-base vs-input--label">
							Yêu cầu kiểm tra chất lượng
						</label>
					</vs-col>
				</vs-row>
			</div>
		</PerfectScrollbar>

		<div class="flex justify-center" slot="footer">
			<!--<vs-button v-if="!orderNow" class="w-full sm:w-1/3 font-bold" @click.stop="submitData" >{{ id ? "Sửa lệnh" : (data.type == 1 ? "Đặt mua" : "Đặt bán") }}</vs-button>-->
			<vs-button v-if="id && data2.type==2" class="w-full sm:w-1/3 font-bold" @click.stop="submitDataNow" >Mua ngay</vs-button>
		</div>
		
	</el-dialog>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import SelectAssigned from "@/components/select-assigned/SelectAssigned";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";

let shippingOptions = {};

export default {
	name: "CustomerForm",
	components: { vSelect, SelectAssigned, CbsUploadRef },
	props: {
		isPopupActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			require_qc: 0,
			provinces: [],
			districts: [],
			placeData: [],
			priceMaps: {},
			customErrors: null,
			timeKey: Date.now(),
			files: [],
			value: {},
			product: null,
			supplier: null,
			quantity: null,
			price: null,
			address: null,
			cus_note: null,
			canSelectSupplier: false,
			canBuy: false,
			canSell: false,

			'supplier_name': null,
            'supper_phone': null,
            'supper_mst': null,
            'supplier_bankaccount': null,
            'supplier_bankname': null,
            'supplier_bankowner': null,
			shipping_method: 1,

			id: null,

			fullName: null,
			nickname: null,
			phone: null,
			city: null,
			district: null,
			ward: null,
			street: null,
			assigned: null,
			totalPool: null,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			province: null,
			district: null,
			prevent_slit: 0,
			orderNow: 0,
			data2: {}
		};
	},
	watch: {
		province(val) {
			console.log('province: ', val);
			this.getDistricts();
		},
		isPopupActive(val) {
			if (!val) return;

			const { supplier, product, quantity, price, cus_note, address, photos = [], id = 0, supplier_name, supper_phone, supper_mst, supplier_bankaccount, supplier_bankname, supplier_bankowner, shipping_method,
				shipping_options, type, state_id, district_id, prevent_slit, orderNow = 0, require_qc = 0
			} = this.data;
			this.orderNow = orderNow;
			if (product) {
				this.product = product.id;
			} else {
				this.product = null;
			}
			if (supplier) {
				this.supplier = supplier.id;
			} else {
				this.supplier = null;
			}
			
			if (quantity) {
				this.quantity = quantity;
			} else {
				this.quantity = null;
			}
			if (shipping_options) {
				shippingOptions = shipping_options;
			}
			 else {
				shippingOptions = {};
			}
			if (price) {
				this.price = price;
			} else {
				this.price = null;
			}
			if (supplier_name) {
				this.supplier_name = supplier_name;
			} else {
				this.supplier_name = null;
			}
			if (supper_phone) {
				this.supper_phone = supper_phone;
			} else {
				this.supper_phone = null;
			}
			if (supper_mst) {
				this.supper_mst = supper_mst;
			} else {
				this.supper_mst = null;
			}
			if (supplier_bankaccount) {
				this.supplier_bankaccount = supplier_bankaccount;
			} else {
				this.supplier_bankaccount = null;
			}
			if (supplier_bankname) {
				this.supplier_bankname = supplier_bankname;
			} else {
				this.supplier_bankname = null;
			}
			if (supplier_bankowner) {
				this.supplier_bankowner = supplier_bankowner;
			} else {
				this.supplier_bankowner = null;
			}
			if (address) {
				this.address = address;
			} else {
				this.address = null;
			}
			if (cus_note) {
				this.cus_note = cus_note;
			} else {
				this.cus_note = null;
			}
			if (photos) {
				this.photos = photos;
			} else {
				this.photos = null;
			}
			if (id) {
				this.id = id;
				this.getOrder();
			} else {
				this.id = null;
			}
			if (shipping_method) {
				this.shipping_method = shipping_method;
			}
			if (state_id) {
				this.province = state_id;
			} else {
				this.province = null;
			}
			if (district_id) {
				this.district = district_id;
			} else {
				this.district = null;
			}
			if (prevent_slit) {
				this.prevent_slit = 1;
			} else {
				this.prevent_slit = 0;
			}
			if (require_qc) {
				this.require_qc = 1;
			} else {
				this.require_qc = 0;
			}
			// if (type == 2) {
				this.getPlaces();
			// }

			this.isFormDirty = false;
			this.initFormData = {};
		},

		computedFormData: {
			handler: function (newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
					this.isFormDirty = true;
				}
			},
			deep: true,
		},
		city() {
			if (this.city) {
				this.$store.dispatch("getDistrict", {
					provinceCode: this.city,
				});
			}
		},
		district() {
			if (this.district) {
				this.$store.dispatch("getWard", {
					districtCode: this.district,
				});
			}
		},
	},
	computed: {
		localAttachFile: {
			get() {
				// console.log('this.value: ' , this.value);
				return this.value.attachFile ? [this.value.attachFile] : [];
			},
			set(val) {
				// console.log('set.value: ' , val);
				// console.log(typeof val);
				if (val.length) {
					this.files = val;
				} else if (typeof val === 'number') {
					this.files.splice(val, 1);
				}
				if (this.files.length) {
					this.customErrors = null;
				}
				return this.$emit("input", { ...this.value, attachFile: val && val.length ? val[0] : null });
			}
		},
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			},
		},
		computedFormData() {
			return {
				id: this.id,
				fullName: this.fullName,
				nickname: this.nickname,
				phone: this.phone,
				city: this.city,
				district: this.district,
				ward: this.ward,
				street: this.street,
				assigned: this.assigned,
				totalPool: this.totalPool,
			};
		},
	},
	created() {
		this.getSuppliers();
		this.getProvinces();
		// this.getOrder();
		if (this.$store.state.AppActiveUser) {
			let { permissions = {} } = this.$store.state.AppActiveUser;
			let { supplier_can_select = false, user_can_sell = false, user_can_buy = false} = permissions;
			if (user_can_buy) {
				this.canBuy = true;
			}
			if (user_can_sell) {
				this.canSell = true;
			}
			if (supplier_can_select) {
				this.canSelectSupplier = true;
			}
			// if (user_can_sell) {
			// 	this.getPlaces();
			// }
		}
	},
	methods: {
		getSuppliers() {
			// this.$vs.loading();
			try {
				let payload = {
				};
				this.$store.dispatch("moduleProduct/fetchSuppliers", payload);
				// this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		getProvinces() {
			// this.$vs.loading();
			try {
				let payload = {
				};
				this.$store.dispatch("moduleProduct/getProvinces", payload);
				// this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		getDistricts() {
			// this.$vs.loading();
			try {
				let payload = {
				};
				this.$store.dispatch("moduleProduct/getDistricts", this.province).then(response => {
					this.districts = response ? response : [];
				});
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},

		async getOrder() {
			console.log('getOrder');
			this.$vs.loading();
			try {
				await this.$store.dispatch("moduleProduct/getOrderById", this.id).then(response => {
					// this.sell = response;
					// if (response && response.photos) {
					// 	this.activePhoto = response.photos[0];
					// }
					this.data2 = response;
					console.log('getOrderById: ', response);

					const { supplier, product, quantity, price, cus_note, address, photos = [], id = 0, supplier_name, supper_phone, supper_mst, supplier_bankaccount, supplier_bankname, supplier_bankowner, shipping_method,
						shipping_options, type, state_id, district_id, prevent_slit, orderNow = 0, require_qc = 0
					} = this.data2;
					this.orderNow = orderNow;
					if (product) {
						this.product = product.id;
					} else {
						this.product = null;
					}
					if (supplier) {
						this.supplier = supplier.id;
					} else {
						this.supplier = null;
					}
					
					if (quantity) {
						this.quantity = quantity;
					} else {
						this.quantity = null;
					}
					if (shipping_options) {
						shippingOptions = shipping_options;
					}
					else {
						shippingOptions = {};
					}
					if (price) {
						this.price = price;
					} else {
						this.price = null;
					}
					if (supplier_name) {
						this.supplier_name = supplier_name;
					} else {
						this.supplier_name = null;
					}
					if (supper_phone) {
						this.supper_phone = supper_phone;
					} else {
						this.supper_phone = null;
					}
					if (supper_mst) {
						this.supper_mst = supper_mst;
					} else {
						this.supper_mst = null;
					}
					if (supplier_bankaccount) {
						this.supplier_bankaccount = supplier_bankaccount;
					} else {
						this.supplier_bankaccount = null;
					}
					if (supplier_bankname) {
						this.supplier_bankname = supplier_bankname;
					} else {
						this.supplier_bankname = null;
					}
					if (supplier_bankowner) {
						this.supplier_bankowner = supplier_bankowner;
					} else {
						this.supplier_bankowner = null;
					}
					if (address) {
						this.address = address;
					} else {
						this.address = null;
					}
					if (cus_note) {
						this.cus_note = cus_note;
					} else {
						this.cus_note = null;
					}
					if (photos) {
						this.photos = photos;
					} else {
						this.photos = null;
					}
					if (id) {
						this.id = id;
					} else {
						this.id = null;
					}
					if (shipping_method) {
						this.shipping_method = shipping_method;
					}
					if (state_id) {
						this.province = state_id;
					} else {
						this.province = null;
					}
					if (district_id) {
						this.district = district_id;
					} else {
						this.district = null;
					}
					if (prevent_slit) {
						this.prevent_slit = 1;
					} else {
						this.prevent_slit = 0;
					}
					if (require_qc) {
						this.require_qc = 1;
					} else {
						this.require_qc = 0;
					}
					
				});
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		getPlaces() {
			// this.$vs.loading();
			try {
				let payload = {
				};
				this.$store.dispatch("moduleProduct/getPlaces", payload).then(response => {
					if (response) {
						if (response.hasOwnProperty('priceMaps') && Object.keys(response.priceMaps).length && this.id == null) {
							this.priceMaps = response.priceMaps;
						} else {
							this.priceMaps = shippingOptions;
						}
						if (response.hasOwnProperty('places')) {
							this.placeData = response.places;
						}
						if (this.id == null) {
							if (response.hasOwnProperty('province')) {
								this.province = response.province;
							}
							if (response.hasOwnProperty('district')) {
								this.district = response.district;
							}
						}
					} else {
						this.priceMaps = shippingOptions;
					}
					// const { shipping_options } = this.data;
					// console.log('shipping_options: ', shipping_options);
					// if (shipping_options && shipping_options.length) {
					// 	this.priceMaps = shipping_options;
					// } else {
					// 	this.priceMaps = [];
					// }
					// console.log('this.data: ', this.data);
					// this.priceMaps = {"1_1": 40};
				});
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		handleChangeFile(uploadedFiles) {
			console.log('handleChangeFile: ', uploadedFiles);
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.supplier_name = null;
			this.supper_phone = null;
			this.supper_mst = null;
			this.supplier_bankaccount = null;
			this.supplier_bankname = null;
			this.supplier_bankowner = null;
			this.address = null;
			this.supplier = null;
			this.cus_note = null;
			this.orderNow = 0;
			// this.shipping_method = "1";
			// this.priceMaps = {};
			this.$validator.reset();
		},
		submitDataNow() {
			this.orderNow = 1;
			this.submitData();
		},
		submitData() {
			let ppms = {};
			for (let k in this.priceMaps) {
				ppms[k] = this.priceMaps[k];
			}
			this.$validator.validateAll().then((result) => {
				let photoFiles = this.files.map(item => item.id);
				if (this.data.type == 2 && !photoFiles.length && !this.id) {
					this.customErrors = 'Cần vài ảnh thực tế của sản phẩm để người mua quyết định';
					return;
				}
				if (result) {
					const dataObj = {
						type: this.data.type,
						productId: this.product,
						supplierId: this.supplier,
						cus_note: this.cus_note,
						quantity: this.quantity,
						price: this.price,
						address: this.address,
						'supplier_name': this.supplier_name,
						'supper_phone': this.supper_phone,
						'supper_mst': this.supper_mst,
						'supplier_bankaccount': this.supplier_bankaccount,
						'supplier_bankname': this.supplier_bankname,
						'supplier_bankowner': this.supplier_bankowner,
						id: this.id,
						photos: photoFiles,
						shipping_method : this.shipping_method,
						shipping_options: ppms,
						state_id: this.province,
						district_id: this.district,
						prevent_slit: this.prevent_slit,
						orderNow: this.orderNow,
						require_qc: this.require_qc
					};
					console.log("[SUBMIT]", dataObj);

					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			if (this.supplier == 0) {
				this.getSuppliers();
			}
			if (!this.id) {
				this.initValues();
			}
			// if (this.id) {
			// 	this.$emit("closePopup");
			// }
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Đặt lệnh thành công",
				},
			});
			if (this.orderNow) {
				setTimeout(() => {
					this.$router.push('/cac-lenh-ban');
				}, 1000);
			}
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/createOrder", dataObj).then(response => {
					this.handleCreateOrUpdateSuccess(response);
				});
				// this.handleCreateOrUpdateSuccess();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
};
</script>

<style>
 .fieldset-custom {
	padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.2);
 }
 .vs-checkbox--check {
	/*
	-webkit-transform: translate(0%) !important;
	transform: translate(0%) !important;
	*/
	display: none;
 }
 .vs-checkbox--input:checked+.vs-checkbox .vs-checkbox--check {
	display: block;
 }
</style>